// extracted by mini-css-extract-plugin
export default {"container":"Discover_container__T1xF_","nexsetAction":"Discover_nexsetAction__1heBm"};